import React from 'react';
import { DropdownItem } from 'reactstrap';
import { User, FileText, Star, Settings, Droplet } from 'react-feather';
import user1 from '../../assets/images/users/user4.jpg';

const ProfileDD = ( {userPhoto}) => {
  const user = JSON.parse(sessionStorage.getItem('user'));

  return (
    <div>
      <div className="d-flex gap-3 p-3 border-bottom pt-2 align-items-center">
      {userPhoto ? (
                  <img
                    src={userPhoto}
                   alt="user" className="rounded-circle" width="60"
                  />
                ) : (
                  <img
                    src="/ruta/a/imagen-default.png"
                   alt="user" className="rounded-circle" width="60"
                  />
                )}
        <span>
          <h5 className="mb-0">{user.name}</h5>
          <small className="fs-6 text-muted"></small>
        </span>
      </div>
      {/* <DropdownItem className="px-4 py-3">
        <User size={20} />
        &nbsp; My Profile
      </DropdownItem>
      <DropdownItem className="px-4 py-3">
        <FileText size={20} />
        &nbsp; Edit Profile
      </DropdownItem>
      <DropdownItem className="px-4 py-3">
        <Star size={20} />
        &nbsp; My Balance
      </DropdownItem>
      <DropdownItem className="px-4 py-3">
        <Droplet size={20} />
        &nbsp; Customize
      </DropdownItem>
      <DropdownItem divider />
      <DropdownItem className="px-4 py-3">
        <Settings size={20} />
        &nbsp; Settings
      </DropdownItem>
      <DropdownItem divider /> */}
    </div>
  );
};

export default ProfileDD;
